<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Stock Transfer Receipt #{{data.code}}</h4>
                    <p class="text-subtitle-1">Stock Transfer Receipt Voucher Information</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <!-- TODO: Hide and Show actions according to state_code after backend finish -->
                <v-col cols="12" md="3" v-if="isPostable">
                    <v-btn block color="primary" @click="handlePost" :loading="postLoading">
                        <v-icon left>mdi-post</v-icon>
                        post
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="isPrintable">
                    <v-btn block depressed @click="handlePrint" :loading="printLoading">
                        <v-icon left>mdi-printer</v-icon>
                        print
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="isEditable">
                    <v-btn block depressed @click="handleUpdate">
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="isDeletable">
                    <v-btn block depressed color="error--text" @click="handleDelete" :loading="deleteLoading">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Code</th>
                                <td class="font-weight-bold">{{data.code}}</td>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <td>{{data.date}}</td>
                            </tr>
                            <tr>
                                <th>Source Warehouse</th>
                                <td class="font-weight-bold">{{data.source_warehouse ? data.source_warehouse.display_name : ""}}</td>
                            </tr>
                            <tr>
                                <th>Target Warehouse</th>
                                <td>{{data.target_warehouse ? data.target_warehouse.display_name : ""}}</td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>
                                    <PStatus :state="data.state"/>
                                </td>
                            </tr>
                            <tr>
                                <th>Stock Transfer Code</th>
                                <td @click="handleDisplayStockTransfer(data.stock_transfer.id)">
                                    <span class="text-decoration-underline font-weight-bold" style="cursor: pointer" v-if="data && data.stock_transfer">
                                        {{data.stock_transfer.code}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Unit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(d, i) in data.lines" :key="i">
                                <td>{{i+1}}</td>
                                <td>{{d.item.display_name}}</td>
                                <td>{{d.quantity}}</td>
                                <td>{{d.measure_unit.abbreviation}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Notes</th>
                                <td>{{data.notes}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Created By</th>
                                <td>
                                    <span v-if="data && data.created_by">
                                        {{data.created_by.first_name}} {{data.created_by.last_name}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>Created At</th>
                                <td>{{data.created_at}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Updated By</th>
                                <td>
                                    <span v-if="data && data.updated_by">
                                        {{data.updated_by.first_name}} {{data.updated_by.last_name}}
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>Updated At</th>
                                <td>
                                    <span v-if="data && data.updated_at">
                                            {{data.updated_at}}
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Posted By</th>
                                <td>
                                    <span v-if="data && data.posted_by">
                                        {{data.posted_by.first_name}} {{data.posted_by.last_name}}
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>Posted At</th>
                                <td>
                                    <span v-if="data && data.posted_at">
                                            {{data.posted_at}}
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="4">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="4">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import stockTransferReceiptAPI from '../../../services/stockJournal/stockTransferReceipt';
import PAlert from '../../../components/common/PAlert.vue';
import PStatus from './../../../components/common/PStatus.vue';
import permissions from '../../../data/permissions';
import authorize from '../../../utils/authorize';

export default {
    components: {
        PAlert,
        PStatus
    },
    data() {
        return {
            id: null,
            loading: false,
            deleteLoading: false,
            printLoading: false,
            postLoading: false,
            data: {},
            alert:{
                value: false,
                content: 'Are you sure?',
                callback: null
            },
            permissions
        }
    },
    computed: {
        isEditable() {
            return this.data && this.data.meta && this.data.meta.is_editable && this.hasPermission(this.permissions.stock_transfer_receipt.update);
        },
        isDeletable() {
            return this.data && this.data.meta && this.data.meta.is_deletable && this.hasPermission(this.permissions.stock_transfer_receipt.delete);
        },
        isPostable() {
            return this.data && this.data.meta && this.data.meta.is_postable && this.hasPermission(this.permissions.stock_transfer_receipt.post);
        },
        isPrintable() {
            return this.data && this.data.meta && this.data.meta.is_printable && this.hasPermission(this.permissions.stock_transfer_receipt.print);
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            stockTransferReceiptAPI.find(this.id).then(response => {
                this.data = response.data
            }).finally(() => {
                this.loading =false;
            })
        },
        handleDelete() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to delete?", callback: this.remove}
        },
        remove() {
            this.deleteLoading = true;
            stockTransferReceiptAPI.remove(this.id).then(() => {
                this.$router.replace({
                    name: "TransferReceiptVoucherList"
                })
            }).finally(() => {
                this.deleteLoading = false;
            })
        },
        handleUpdate() {
            this.$router.push({
                name: "TransferReceiptVoucherEdit",
                params: {
                    id: this.id
                }
            })
        },
        handlePost() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to post?", callback: this.post }
        },
        post() {
            this.postLoading = true;
            stockTransferReceiptAPI.post(this.id).then(response => {
                this.data = response.data;
                setTimeout(() => {
                    this.fetch();
                }, 800)
            }).finally(() => {
                this.postLoading = false;
            })
        },
        handlePrint() {
            this.printLoading = true;
            stockTransferReceiptAPI.print(this.id)
                .then(response => {
                    var printWindow = window.open('','','width=800,height=600');
                    printWindow.document.write(response.data);
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                    printWindow.close();
                }).finally(() => {
                    this.printLoading = false;
                })
        },
        hasPermission(code) {
            return authorize(code)
        },
        handleDisplayStockTransfer(stockTransferId) {
            this.$router.push({
                name: "TransferIssueVoucherDisplay",
                params: {
                    id: stockTransferId
                }
            })
        } 
    },
    created() {
        this.id = this.$route.params.id;
        this.fetch();
    }
}
</script>

<style>

</style>